import { Component } from '@theme/component';
import { getScrollContainer, scrollContainerMediaQuery } from '@theme/scroll-container';

import { loadMotion } from './motion-library.js';

/** Enhances the Liquid heading; content stays visible if animation cannot load. */
class TitanCollectionHeading extends Component {
  #version = 0;
  #controller;
  #context;
  #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#motion.addEventListener('change', this.#setup, { signal: this.#controller.signal });
    scrollContainerMediaQuery.addEventListener('change', this.#setup, { signal: this.#controller.signal });
    this.#setup();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#setup();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#version++;
    this.#controller?.abort();
    this.#context?.revert();
    this.#context = undefined;
  }

  #setup = async () => {
    const version = ++this.#version;
    this.#context?.revert();
    this.#context = undefined;
    if (this.dataset.motionEnabled !== 'true' || this.#motion.matches || !this.isConnected) return;

    try {
      const gsap = await loadMotion();
      if (version !== this.#version || !this.isConnected || this.#motion.matches || this.dataset.motionEnabled !== 'true') return;
      this.#context = gsap.context(() => {
        const title = this.querySelector('.titan-section-heading__title');
        const marker = this.querySelector('.titan-section-heading__marker');
        if (title) gsap.fromTo(title, { y: 12, opacity: 0.7 }, { y: 0, opacity: 1, duration: 0.7, clearProps: 'transform,opacity' });
        if (marker) gsap.fromTo(marker, { scaleX: 0.65 }, {
          scaleX: 1,
          transformOrigin: getComputedStyle(this).direction === 'rtl' ? 'right' : 'left',
          ease: 'none',
          scrollTrigger: { trigger: this, scroller: getScrollContainer(), start: 'top bottom', end: 'bottom top', scrub: 0.5 },
        });
      }, this);
    } catch {
      // Animation is optional; semantic content and filtering stay available.
    }
  };
}

if (!customElements.get('titan-collection-heading')) {
  customElements.define('titan-collection-heading', TitanCollectionHeading);
}
